import { createFileRoute } from "@tanstack/react-router";

import {
  guardContinuousAuditorFeature,
  redirectToClientOverview,
} from "@/core/lib/feature-guards";

/** Protects the complete v2 results parent route using the active dossier. */
export const Route = createFileRoute(
  "/_protected/auditor/clients/$id/_client-tabs/continuous-auditor-results",
)({
  beforeLoad: ({ context: { active }, params }) => {
    if (!guardContinuousAuditorFeature(active).allowed) {
      redirectToClientOverview(params.id);
    }
  },
});
